import comp from "./MediaUploadButton";
export default comp;
